import { klaroConfig } from './klaro-config';
import * as klaro from 'klaro/dist/klaro-no-css'
import { docReady } from '../theme/events';

docReady(() => {
    klaro.render(klaroConfig);
})
